export enum BmarkClientOrdersBlotterMode {
  DEALT,
  RISK,
}
